import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "reactive" }
const _hoisted_3 = { class: "absolute top-0" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]

import "vue3-carousel/dist/carousel.css"
import { AxiosInstance } from "axios"
import { Carousel, Slide, Pagination, Navigation } from "vue3-carousel"
import { computed, inject, ref } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'FileUploader',
  props: {
  endpoint: String,
  uploadType: String,
  images: Array,
},
  emits: ["update:images"],
  setup(__props, { emit }) {

const props = __props

const axios = inject("$axios") as AxiosInstance



const file = ref()
const imageSync = computed({
  get: () => props.images,
  set: (val) => emit("update:images", props.images?.push),
})
const formData = new FormData()
const onFileSelected = async () => {
  const files = file.value.files
  formData.append("file", files[0])
  formData.append("uploadType", props?.uploadType as string)

  const image = await uploadPic(formData)
  formData.delete("file")
  formData.delete("uploadType")
  if (image) {
    if (typeof props.images === "number") {
      emit("update:images", [{ url: image.imageUrl, link: image.imageUrl }])
    } else {
      emit("update:images", [
        ...props.images,
        { url: image.imageUrl, link: image.imageUrl },
      ])
    }
  }
}

const removeImage = (index: number) => props.images?.splice(index, 1)

const uploadPic = async (formData: FormData) => {
  return await axios
    .post(`${process.env.VUE_APP_API_ENDPOINT}${props.endpoint}`, formData)
    .then(({ data }) => data)
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.images?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(Carousel), { "items-to-show": 1 }, {
            addons: _withCtx(() => [
              _createVNode(_unref(Navigation)),
              _createVNode(_unref(Pagination))
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.images, (slide, index) => {
                return (_openBlock(), _createBlock(_unref(Slide), { key: index }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (removeImage(index))
                        }, [
                          _createElementVNode("span", null, [
                            _createVNode(_component_font_awesome_icon, {
                              class: "text-red-500 m-1 bg-white p-1 text-2xl rounded",
                              icon: ['far', 'trash']
                            })
                          ])
                        ], 8, _hoisted_4)
                      ])
                    ]),
                    _createElementVNode("img", {
                      src: slide.url,
                      alt: "",
                      class: "max-h-44"
                    }, null, 8, _hoisted_5)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("input", {
        type: "file",
        ref_key: "file",
        ref: file,
        class: "hidden",
        onChange: _cache[0] || (_cache[0] = ($event: any) => (onFileSelected()))
      }, null, 544),
      _createElementVNode("button", {
        class: "p-1 bg-blue-400 text-white rounded",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$refs.file.click()))
      }, " add more image ")
    ])
  ], 64))
}
}

})